import TextableModel from '../TextableModel';
import PropertyDescriptor from '../../utils/PropertyDescriptor';

export default class Model extends TextableModel {
    text = new PropertyDescriptor("", '文本', "文本", "text", "#anticon-text", {
        enabled: false
    });
    dateTimeFormat = new PropertyDescriptor("YYYY-MM-DD HH:mm:ss", '时间格式', "时间", "enum", "#anticon-timer1", {
        catalogIndex: 20,
        values: [
            new PropertyDescriptor("YYYY-MM-DD HH:mm:ss", '年-月-日 时:分:秒', undefined, "string"),
            new PropertyDescriptor("YYYY-MM-DD HH:mm", '年-月-日 时:分', undefined, "string"),
            new PropertyDescriptor("YYYY-MM-DD", '年-月-日', undefined, "string"),
            new PropertyDescriptor("HH:mm:ss", '时:分:秒', undefined, "string"),
            new PropertyDescriptor("YYYY-MM-DD dddd", '年-月-日 星期', undefined, "string"),
            new PropertyDescriptor("custom", '自定义', undefined, "string"),
        ]
    });
    dateTimeFormatCustom = new PropertyDescriptor("YYYY-MM-DD HH:mm:ss", '自定义', "时间", "text", "#anticon-text", {
        placeholder: 'eg:YYYY-MM-DD HH:mm:ss',
        visible: false
    });
    isAutoRefresh = new PropertyDescriptor(true, '自动刷新', "时间", "bool", "#anticon-shuaxin5");
    autoRefreshInterval = new PropertyDescriptor(1, '间隔(秒)', "时间", "double", "#anticon-home5", {
        minValue: 1
    });
    constructor(opts = {}) {
        super();
        this.defineAllProperties();

        this.backgroundColor = "transparent";
        this.borderWidth = 0;
        this.fontSize = 24;
        this.width = 300
        for (var p in opts) {
            this[p] = opts[p];
        }
    }

    getType() {
        return "DateTimeModel";
    }
    onPropertyValueChanged(name, valOld, valNew, subName) {
        super.onPropertyValueChanged(name, valOld, valNew, subName);
        if (subName === undefined) {
            switch (name) {
                case "dateTimeFormat":
                    this.setPropertyVisible("dateTimeFormatCustom", valNew === "custom")
                    break;
                case "isAutoRefresh":
                    this.setPropertyVisible("autoRefreshInterval", valNew)
                    break;
            }
        }

    }
}
